<div class="container border border-dark p-4 rounded">
    <h4 class="mb-3">{{ 'vestra_user.vestra_user_search' | translate }}</h4>
    <form (ngSubmit)="onSearch()" [formGroup]="form">
        <div class="mb-3">
            <label class="col-form-label">{{ 'common.search_term' | translate }}</label>
            <input type="text" formControlName="propertyValue" id="propertyValue" class="form-control" [placeholder]="'common.enter_search_term' | translate" />
        </div>

        <div class="mb-3">
            <label class="col-form-label">{{ 'common.criteria' | translate }}</label>
            <select formControlName="propertyName" id="propertyName" class="form-control form-select">
                <option value="">
                    {{ 'common.please_select' | translate }}
                </option>
                <option value="FirstName">{{ 'vestra_user.first_name' | translate }}</option>
                <option value="LastName">{{ 'vestra_user.last_name' | translate }}</option>
            </select>
        </div>

        <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-secondary search-btn" (click)="onClear()" *ngIf="form.dirty">
                <i class="bi bi-x-circle"></i>
                <span class="mx-1">{{ 'common.clear' | translate }}</span>
            </button>
            <button type="submit" class="btn btn-outline-secondary search-btn">
                <i class="bi bi-search"></i>
                <span class="mx-1">{{ 'common.search' | translate }}</span>
            </button>
        </div>
    </form>
</div>
